import { createApi } from '@reduxjs/toolkit/query/react'
import Stamp from '../../types/api/stamp'
import getCustomFetchBase from '../custom-fetch-base'
import Strapi, {
    EndpointQueryParameters,
    StrapiCreate,
    StrapiUpdate,
} from '../../types/strapi/strapi'
import { StrapiSingle } from '../../types/strapi/strapi'
import getQuery from '../../helpers/api/get-query'

export const stampsApi = createApi({
    reducerPath: 'stampsApi',
    baseQuery: getCustomFetchBase({ baseUrl: process.env.REACT_APP_API_URL }),
    tagTypes: ['Stamps', 'Tubes'],
    endpoints: builder => ({
        getStamps: builder.query<Strapi<Stamp>, EndpointQueryParameters | void>({
            query: getQuery('/stamps'),
            providesTags: ['Stamps'],
        }),
        getStampByDocId: builder.query<
            StrapiSingle<Stamp>,
            [string, EndpointQueryParameters] | [string]
        >({
            query: ([docId, params]) => getQuery(`/stamps/${docId}`)(params),
            providesTags: ['Stamps'], // TODO: вычислить места, которые опираются на это поведение и отрефакторить
        }),
        createStamp: builder.mutation<StrapiSingle<Stamp>, StrapiCreate<Stamp>>({
            query: body => ({
                url: '/stamps',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['Stamps'],
            // TODO: обновить получение штампа по док ид, закинуть туда в кэш созданный штамп
        }),
        updateStamp: builder.mutation<StrapiSingle<Stamp>, StrapiUpdate<Stamp>>({
            query: ({ docId, body }) => ({
                url: `/stamps/${docId}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['Stamps', 'Tubes'],
        }),
    }),
})

export const {
    useGetStampsQuery,
    useLazyGetStampsQuery,
    useGetStampByDocIdQuery,
    useLazyGetStampByDocIdQuery,
    useCreateStampMutation,
    useUpdateStampMutation,
} = stampsApi
